import { DataModel } from "common/models/utility-models/base-model";
import { UploadFileModel } from "../../custom-model/uploadfile.model";


export class StudentProfileModel extends DataModel {
  user_id: number = 0;
  first_name: string = '';
  last_name: string = '';
  father_name: string = '';
  mother_name: string = '';
  mobile_number: string = '';
  parentMobileNumber: string = '';
  email: string = '';
  gender: any;
  address: string = '';
  age: string = '';
  region: string = '';
  region_id: number = 0;
  state_id: number = 0;
  state_name: number = 0;
  district: string = '';
  district_id: number = 0;
  name_of_college: string = '';
  college_address: string = '';
  batch_duration_start: string = '';
  batch_id: number = 0;
  branch_id: number = 0;
  branch_name: any = null;
  batch_number: string = '';
  unique_batch_id: string = '';
  mentor_name: string = '';
  mentor_email: string = '';
  mentor_mobile: string = '';
  summer_vacation_start_date: string = '';
  summer_vacation_end_date: string = '';
  winter_vacation_start_date: string = '';
  winter_vacation_end_date: string = '';
  first_year_score: number = 0.0;
  second_year_score: number = 0.0;
  third_year_score: number = 0.0;
  fourth_year_score: number = 0.0;
  first_year2_score: number = 0.0;
  second_year2_score: number = 0.0;
  third_year2_score: number = 0.0;
  fourth_year2_score: number = 0.0;
  ktsem1: number = 0;
  ktsem2: number = 0;
  ktsem3: number = 0;
  ktsem4: number = 0;
  ktsem5: number = 0;
  ktsem6: number = 0;
  ktsem7: number = 0;
  ktsem8: number = 0;
  placement_company_name: string = '';
  placement_company_location: string = '';
  placement_company_designation: string = '';
  // placement_company_package_id_id: string = '';
  placement_company_package: string = '';
  placement_company_type: any = '';
  industryType: any = null;
  first_year_credit: number = 0.0;
  second_year_credit: number = 0.0;
  third_year_credit: number = 0.0;
  fourth_year_credit: number = 0.0;
  year: any = 1;
  batchs: any = [];
  uploadedFileOriginalName: any = '';
  profile_pic_path: string = '';
  semester: any = '';

  fee_receipt: any = '';

  studentAchievementDetails: any = [];
  studentDocumentDetails: UploadFileModel | any = [];
  apiStudentDocumentDetailsList: any = [];
  title: string = '';
  fileOriginalName: any = '';
  // user_id:number=0
  other: any;
}

export class studentDetailsForm {
  user_id: number = 0;
  mobile_number: '';
  email: '';
  address: '';
  gender: '';
  profile_pic_path: any;
  state_id: '';
  summer_vacation_start_date: '';
  summer_vacation_end_date: '';
  winter_vacation_start_date: '';
  winter_vacation_end_date: '';
  first_year_score: '';
  second_year_score: '';
  third_year_score: '';
  fourth_year_score: '';
  first_year2_score: '';
  second_year2_score: '';
  third_year2_score: '';
  fourth_year2_score: '';
  fee_receipt: '';
  student_id: '';
  // doc: []=[];
  achivements: '';
  placement_company_package: '';
  placement_company_name: '';
  placement_company_location: '';
  placement_company_designation: '';
  parentMobileNumber: '';
  district: '';
  region_id: number = 0;
  district_id: number = 0;
  other:any;

}
